<template>
  <div class="home">
  	<Card>
  	  	<template #title>Dashboard</template>
  	  	<template #content>
        	<p>More content might go here at some point, but for now, you can access your domains on the bar at the top right.</p>
        	<p>If you haven't already, please set up two factor authentication under your account settings.</p>
        	<p>For general support issues, contact Jeff, Ben or <a href="mailto:support@harborwall.com?subject=everything is on FIRE!">support@harborwall.com</a> (which, suprisingly, goes to both Jeff and Ben).  For app support issues, contact Ben.</p>
    	</template>
  	</Card>
  </div>
</template>
<script>

export default {
  name: 'Home',
  components: {
  }
}
</script>
